import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind-aware class joiner. Last class wins per Tailwind group. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
